import { flexboxAlignItemsCenterCss } from "@/components/components.style";

export const footerCss = [
  {
    justifyContent: "space-between",
  },
  flexboxAlignItemsCenterCss,
];

export const footerRightCss = [flexboxAlignItemsCenterCss];

export const footerViewLinkCss = {
  textDecoration: "none",
};

export const buttonCss = [
  {
    padding: "16px 8px",
  },
  flexboxAlignItemsCenterCss,
];

export const reorderButtonCss = [
  {
    ":hover": {
      cursor: "grab",
    },
  },
  buttonCss,
];
